export default __webpack_public_path__ + "static/V-ISO_Liian_korkea_ISO2-82e9eac42c8c27921369f35cae8d9812.jpg";